import { ApplicationController } from 'stimulus-use';

export default class extends ApplicationController {
  static targets = ['slide', 'feature'];

  static values = {
    interval: { type: Number, default: 3000 },
  };

  connect() {
    this.index = 0;
    this.showCurrent();

    this.timer = setInterval(() => this.next(), this.intervalValue);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  next() {
    this.slideTargets[this.index].classList.remove('opacity-100');
    this.slideTargets[this.index].classList.add('opacity-0');
    this.featureTargets[this.index].classList.remove('opacity-100', 'text-brand');
    this.featureTargets[this.index].classList.add('opacity-50', 'text-gray-700');
    this.index = (this.index + 1) % this.slideTargets.length; // rotate
    this.showCurrent(); // fade next in
  }

  showCurrent() {
    this.slideTargets[this.index].classList.remove('opacity-0');
    this.slideTargets[this.index].classList.add('opacity-100');
    this.featureTargets[this.index].classList.remove('opacity-50', 'text-gray-700');
    this.featureTargets[this.index].classList.add('opacity-100', 'text-brand');
  }
}
